"use strict";

/* globals axios */
document.addEventListener('DOMContentLoaded', function () {
  var MICROSERVICE_URL = 'https://be-fit-api.now.sh';
  var enteringPostcode;
  var selectShippingBtn = document.querySelector('[data-cart-menu-button-calculate-shipping]');
  var selectDeliveryOption = document.querySelector('[data-select-delivery-option]');
  var postcodeElement = document.querySelector('[data-delivery-postcode]');
  var postcodeInput = document.getElementById('address_zip');
  var submitBtn = document.querySelector('[data-cart-menu-button-checkout]');
  var cartMenuShippingNote = document.querySelector('.cart-menu-shipping-note');
  var deliveryTypeElement = document.querySelector('[data-select-delivery-option]');
  var selectOptionsElement = document.querySelector('[data-delivery-days]');
  var selectPickupLocations = document.querySelector('[data-delivery-pickup-locations]');
  var selectPickupDateTime = document.querySelector('[data-pickup-date-time-select]');
  var pickupLocationAddress = document.querySelector('[data-delivery-pickup-address]');
  /**
   * Pickup related order attribute inputs.
   */

  var pickupLocationAddressInput = document.querySelector('[name="attributes[Pickup Address]"]');
  var pickupLocationLocationInput = document.querySelector('[name="attributes[Pickup Location]"]');
  var pickupLocationDateInput = document.querySelector('[name="attributes[Pickup Date]"]');
  var pickupLocationDayInput = document.querySelector('[name="attributes[Pickup Day]"]');
  var pickupLocationHoursInput = document.querySelector('[name="attributes[Pickup Hour Range]"]');
  var attributePostcode = document.querySelector('[name="attributes[Delivery Postcode]"]');
  var attributeMethod = document.querySelector('[name="attributes[Delivery Method]"]');
  var attributeDay = document.querySelector('[name="attributes[Delivery Day]"]');
  var attributeDate = document.querySelector('[name="attributes[Delivery Date]"]');
  var attributeOption = document.querySelector('[name="attributes[Delivery Option]"]');
  var attributeRoute = document.querySelector('[name="attributes[Route]"]');
  var weekdayNatural = new Array(7);
  weekdayNatural[0] = 'Monday';
  weekdayNatural[1] = 'Tuesday';
  weekdayNatural[2] = 'Wednesday';
  weekdayNatural[3] = 'Thursday';
  weekdayNatural[4] = 'Friday';
  weekdayNatural[5] = 'Saturday';
  weekdayNatural[6] = 'Sunday';
  var DELIVERY_METHOD_SAME_DAY = 'Express Shipping';
  var sameDayDeliveryAvailable = selectOptionsElement.hasAttribute('data-delivery-same-day-available');
  var sameDayDeliveryNoteElem = document.querySelector('.cart-menu-same-day-shipping-note');
  var sameDayDeliveryAmountElem = document.querySelector('[data-same-day-shipping-amount]'); // Reinitialise event listeners for the select dropdown

  function initialiseEventListeners() {
    selectOptionsElement.addEventListener('change', function (event) {
      var selectElement = event.target;
      var selectedElem = selectElement.options[selectElement.selectedIndex];
      var selectedMethod = selectedElem.dataset.method;
      var selectedDay = selectedElem.value;
      var selectedDate = selectedElem.dataset.date;
      var selectedRoute = selectedElem.dataset.zone;
      var selectedOption = selectedElem.dataset.option;

      if (selectedMethod && selectedDay && selectedDate && selectedRoute && selectedOption) {
        attributeMethod.value = selectedMethod;
        attributeDay.value = selectedDay;
        attributeDate.value = selectedDate;
        attributeRoute.value = selectedRoute;
        attributeOption.value = selectedOption;
      }

      if (selectedMethod === DELIVERY_METHOD_SAME_DAY) {
        sameDayDeliveryNoteElem.style.display = 'block';
      } else {
        sameDayDeliveryNoteElem.style.display = 'none';
      }
    });
  }
  /**
  * Fetches the next possible delivery dates for a particular postcode from the API.
  * @param {integer} postcode
  */


  function getDeliveryOptions(postcode) {
    // Fetch the delivery days from the API (URL May change?)
    axios.get("".concat(MICROSERVICE_URL, "/delivery/").concat(postcode)).then(function (res) {
      // Disable the submit button and empty the select
      // if there are no options or there is an error.
      if (res.data.error || res.data.delivery.length === 0) {
        if (submitBtn) {
          submitBtn.disabled = true;
        }

        if (selectOptionsElement) {
          selectOptionsElement.innerHTML = '';
        }

        return;
      }

      submitBtn.disabled = false;
      var dates = res.data.delivery;
      var zone = res.data.zone;
      var htmlOptions = ''; // If express shipping is available

      if (sameDayDeliveryAvailable) {
        // Move express shipping option to the end
        var sameDayDeliveryIndex = dates.findIndex(function (date) {
          return date.deliveryMethod === DELIVERY_METHOD_SAME_DAY;
        });

        if (sameDayDeliveryIndex !== -1) {
          dates = dates.concat(dates.splice(sameDayDeliveryIndex, 1));
        }
      } else {
        // Remove express shipping option
        dates = dates.filter(function (date) {
          return date.deliveryMethod !== DELIVERY_METHOD_SAME_DAY;
        });
      } // Updates the HTML of the select dropdown


      dates.forEach(function (date) {
        htmlOptions += "<option value=\"".concat(date.deliveryDateDay, "\" data-method=\"").concat(date.deliveryMethod, "\" data-date=\"").concat(date.formattedDate, "\" data-zone=\"").concat(zone, "\" data-option=").concat(date.option, ">").concat(date.deliveryMethod === DELIVERY_METHOD_SAME_DAY ? 'Express Shipping 6:00pm-9:00pm*' : date.selectDate, "</option>");
      });
      var firstAvailableDate = dates[0];
      attributeMethod.value = firstAvailableDate.deliveryMethod;
      attributeDay.value = firstAvailableDate.deliveryDateDay;
      attributeDate.value = firstAvailableDate.formattedDate;
      attributeRoute.value = zone;
      attributePostcode.value = postcode;
      attributeOption.value = firstAvailableDate.option;

      if (selectOptionsElement) {
        selectOptionsElement.innerHTML = htmlOptions;

        if (attributeMethod.value === DELIVERY_METHOD_SAME_DAY) {
          sameDayDeliveryNoteElem.style.display = 'block';
        } else {
          sameDayDeliveryNoteElem.style.display = 'none';
        }

        initialiseEventListeners();
      }
    }); // Fetch shipping rates so we can display express shipping amount if applicable

    if (sameDayDeliveryAmountElem) {
      // Hardcoding Australia and Victoria as this is the only region express shipping is available
      axios.get("/cart/shipping_rates.json?shipping_address[zip]=".concat(postcode, "&shipping_address[country]=Australia&shipping_address[province]=Victoria"), {
        withCredentials: true
      }).then(function (res) {
        var data = res.data;
        var shipping_rates = data.shipping_rates;
        var sameDayShippingRegex = /(express shipping)/i;
        var sameDayShippingRate = shipping_rates.find(function (rate) {
          return sameDayShippingRegex.test(rate.name);
        });

        if (sameDayShippingRate) {
          sameDayDeliveryAmountElem.innerHTML = " of $".concat(sameDayShippingRate.price);
        }
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }
  /**
   * Sanity check for pickup locations dropdown.
   */


  if (selectPickupLocations) {
    var removePickupLocation = function removePickupLocation() {
      var removeIndex = -1;

      if (selectDeliveryOption) {
        for (var i = 0; i < selectDeliveryOption.length; i++) {
          if (selectDeliveryOption[i].hasAttribute('data-pickup')) {
            removeIndex = i;
            break;
          }
        }

        if (removeIndex != -1) {
          selectDeliveryOption.remove(removeIndex);
        }
      }
    };
    /**
     * Get the available stores for pickup.
     */


    axios.get("".concat(MICROSERVICE_URL, "/pickup/stores/")).then(function (res) {
      if (!res.data.length) {
        console.warn('No pickup locations found, removing pickup option');
        removePickupLocation();
        return;
      }
      /**
       * Populate the first select with the store name and address.
       */


      var storesData = res.data.map(function (_ref) {
        var Store = _ref.Store,
            Address = _ref.Address;
        return {
          Store: Store,
          Address: Address
        };
      });
      storesData.forEach(function (_ref2) {
        var Store = _ref2.Store,
            Address = _ref2.Address;
        var optionElement = document.createElement('option');
        optionElement.value = Store;
        optionElement.dataset.store = Store;
        optionElement.dataset.address = Address;
        optionElement.textContent = Store;
        selectPickupLocations.appendChild(optionElement);
      });
      selectPickupLocations.addEventListener('change', function (e) {
        var locationName = e.target.value;
        var locationAddress = e.target.selectedOptions[0].dataset.address;

        if (submitBtn) {
          submitBtn.disabled = true;
        }
        /**
         * Update the displayed address.
         */


        pickupLocationAddress.textContent = locationAddress;
        /**
         * Update the checkout attribute fields with the new value.
         */

        pickupLocationLocationInput.value = locationName;
        pickupLocationAddressInput.value = locationAddress;
        /**
         * Query the microservice for the available pickup times.
         */

        axios.get("".concat(MICROSERVICE_URL, "/pickup/").concat(locationName, "/")).then(function (_ref3) {
          var data = _ref3.data;

          if (data.error || !data.pickup.length) {
            console.error('Something went wrong.');
          }
          /**
           * Output a default placeholder to force the user to select a time.
           */


          selectPickupDateTime.innerHTML = '';
          var defaultOptionElement = document.createElement('option');
          defaultOptionElement.textContent = 'Select a time.';
          defaultOptionElement.value = '';
          defaultOptionElement.disabled = true;
          defaultOptionElement.selected = true;
          selectPickupDateTime.appendChild(defaultOptionElement);
          /**
           * Output the available pickup times.
           */

          data.pickup.forEach(function (_ref4) {
            var dayOfWeek = _ref4.dayOfWeek,
                date = _ref4.date,
                hours = _ref4.hours,
                selectDate = _ref4.selectDate;
            var optionElement = document.createElement('option');
            optionElement.value = date;
            optionElement.dataset.date = date;
            optionElement.dataset.dayOfWeek = dayOfWeek;
            optionElement.dataset.hours = hours;
            optionElement.textContent = selectDate;
            selectPickupDateTime.appendChild(optionElement);
          });
        });
      });
    });
    /**
     * Update the attribute values once a customer selects date and time.
     */

    selectPickupDateTime.addEventListener('change', function (event) {
      var selectedOption = event.target.selectedOptions[0];
      var _selectedOption$datas = selectedOption.dataset,
          date = _selectedOption$datas.date,
          dayOfWeek = _selectedOption$datas.dayOfWeek,
          hours = _selectedOption$datas.hours;
      pickupLocationDateInput.value = date;
      pickupLocationDayInput.value = dayOfWeek;
      pickupLocationHoursInput.value = hours;

      if (submitBtn) {
        submitBtn.disabled = false;
      }
    });
  }
  /**
   * Prepopulate the postcode and delivery day if they are already part of the cart attributes.
   */


  if (attributePostcode.value) {
    setTimeout(function () {
      postcodeInput.value = attributePostcode.value;
      getDeliveryOptions(parseInt(attributePostcode.value, 10));
    }, 1000);
  } else if (localStorage.getItem('estimatedPostcode')) {
    setTimeout(function () {
      var estimatedPostcode = localStorage.getItem('estimatedPostcode');
      postcodeInput.value = estimatedPostcode;
      getDeliveryOptions(parseInt(estimatedPostcode, 10));
    }, 1000);
  }

  if (selectShippingBtn) {
    selectShippingBtn.addEventListener('click', function () {
      var deliveryType = deliveryTypeElement.options[deliveryTypeElement.selectedIndex].value;
      setTimeout(function () {
        if (submitBtn) {
          if (deliveryType === 'delivery') {
            if (postcodeInput.value && selectOptionsElement.value) return;
            submitBtn.disabled = true;
          } else {
            if (pickupLocationDateInput.value && pickupLocationLocationInput.value) return;
            submitBtn.disabled = true;
          }
        }
      }, 300);
    });
  }

  if (selectDeliveryOption) {
    selectDeliveryOption.addEventListener('change', function () {
      var day = document.querySelector('[data-delivery-day]');
      var pickup = document.querySelector('[data-delivery-pickup-address-field]');
      var pickupLocation = document.querySelector('[data-delivery-pickup-location]');
      var pickupLocationDateTime = document.querySelector('[data-pickup-date-time]');
      /**
       * When the shipping method changes, erase the order attributes from the other method.
       * e.g if delivery erase Pickup Location etc
       */

      if (selectDeliveryOption.value === 'delivery') {
        if (postcodeElement && day && pickup) {
          postcodeElement.style.display = 'block';
          day.style.display = 'block';
          cartMenuShippingNote.style.display = 'block';
          pickup.style.display = 'none';
          pickupLocation.style.display = 'none';
          pickupLocationDateTime.style.display = 'none';
          pickupLocationLocationInput.value = '';
          pickupLocationAddressInput.value = '';
          pickupLocationDateInput.value = '';
          pickupLocationHoursInput.value = '';
          selectPickupDateTime.innerHTML = '';
          selectPickupLocations.options[0].selected = true;
          pickupLocationAddress.textContent = '';

          if (submitBtn) {
            submitBtn.disabled = true;
          }
        }
      } else if (postcodeElement && day && pickup) {
        pickup.style.display = 'block';
        pickupLocation.style.display = 'block';
        pickupLocationDateTime.style.display = 'block';
        postcodeElement.style.display = 'none';
        day.style.display = 'none';
        cartMenuShippingNote.style.display = 'none';
        attributeMethod.value = '';
        attributeDay.value = '';
        attributeDate.value = '';
        attributeOption.value = '';
        attributePostcode.value = '';
        attributeRoute.value = '';

        if (submitBtn) {
          submitBtn.disabled = true;
        }

        if (selectOptionsElement) {
          selectOptionsElement.innerHTML = '';
        }

        if (postcodeInput) {
          postcodeInput.value = '';
        }
      }

      sameDayDeliveryNoteElem.style.display = 'none';
    });
  }

  if (postcodeInput) {
    postcodeInput.addEventListener('keyup', function () {
      if (submitBtn) {
        submitBtn.disabled = true;
      }

      if (selectOptionsElement) {
        selectOptionsElement.innerHTML = '';
      }

      if (enteringPostcode !== undefined) {
        clearTimeout(enteringPostcode);
      }

      enteringPostcode = setTimeout(function () {
        if (!postcodeInput.validity.valid) return;
        if (!postcodeInput.value.length) return;
        getDeliveryOptions(postcodeInput.value);
      }, 500);
    });
  }
  /**
   * Always set the select to delivery on load.
   */


  if (selectDeliveryOption) {
    Array.from(selectDeliveryOption.children).forEach(function (e) {
      if (e.value === 'delivery') e.selected = true;
      submitBtn.disabled = true;
    });
  }
});